// components
import { Form, Input, Select, Checkbox } from "antd";
import { Head } from "components/molecules/Head/Head";
import { useOfferRedemptionPage } from "containers/OfferRedemption/useOfferRedemptionPage";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import Spinner from "components/atoms/Spinner/Spinner";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";
import getIcon from "utils/getIcon";

// styles
import styles from "containers/OfferRedemption/offerRedemption.module.css";

// constants
import { PageTitles } from "constants/global";

const OfferRedemptionPage = () => {
	const {
		cardNumber,
		handleCardNumber,
		form,
		codeCountError,
		handleCheckboxChange,
		// isRedeemed,
		handleRemarks,
		receipt,
		handleReceipt,
		offer,
		offerLabel,
		fetchOfferData,
		handleOffer,
		offerSelect,
		foundOffers,
		redeemOfferSubmit,
		findOfferSubmit,
		remarks,
		loading,
		checkedItems,
		handleSelectAll,
		isAllSelected,
		handleClearAll
	} = useOfferRedemptionPage();

	return (
		<div className="min-h-screen relative">
			{loading && <Spinner type="transparent" />}
			<PageTitle title="Offer Redemption" subTitle="Find and redeem offers" />
			<div className={styles?.root}>
				<Head>{PageTitles.OFFER_REDEMPTION}</Head>

				<Form form={form} requiredMark={false} layout="vertical">
					<div className="grid grid-cols-2 mt-6">
						<Form.Item
							className="mb-auto "
							label={<Label requiredMark label="CR Card Number" classes={{ label: styles?.basic_input_label }} />}
							name="CR Card Number Range Start"
							extra={codeCountError && !cardNumber && <ErrorMessage classes={styles?.err_message} message="This field is required" />}
						>
							<Input
								className={`${styles?.input_field}  ${cardNumber ? styles?.filled : ""}`}
								placeholder=""
								value={cardNumber}
								onChange={(e) => handleCardNumber(e.target.value as any)}
							/>
						</Form.Item>
					</div>
					{foundOffers ? (
						<div className=" grid grid-cols-2 mt-6">
							<Form.Item
								className="mb-auto"
								name="offer"
								requiredMark
								extra={codeCountError && !offer && <ErrorMessage classes={styles?.err_message} message="This field is required" />}
								initialValue={""}
								label={<Label label="Offer" classes={{ label: styles?.basic_input_label }} />}
							>
								<Select
									className={offer ? styles?.active_select_input : styles?.selectInput}
									value={offer}
									bordered={false}
									style={{ textAlign: "center" }}
									onChange={(e) => handleOffer(e)}
									suffixIcon={getIcon({ icon: "caretDropDown" })}
									options={offerSelect}
									showSearch
									optionFilterProp="label"
									filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
								></Select>
							</Form.Item>
						</div>
					) : (
						<></>
					)}

					<div className={` grid grid-cols-2 place-items-end mt-6`}>
						<Button label="Find Offers" onClick={findOfferSubmit} />
					</div>
					{foundOffers ? (
						<>
							<div className="grid grid-cols-2  mt-6 font-bold text-base">{`User: ${cardNumber} Offer : ${offerLabel || ""}`}</div>
							<div className="grid grid-cols-5  mt-6 rounded-lg border-2">
								<div className={styles.headerTable}>Name</div>
								<div className={styles.headerTable}>Acquired Date</div>
								<div className={styles.headerTable}>Start</div>
								<div className={styles.headerTable}>End</div>
								<div className={`${styles.headerTable} ${styles.redeemCheckbox}`}>
									<Checkbox checked={isAllSelected} onChange={(e) => handleSelectAll(e.target.checked)}>
										Redeem?
									</Checkbox>
								</div>
							</div>

							{
								<div>
									{fetchOfferData?.map((item: any, index: number) => {
										return (
											<div key={index} className="grid grid-cols-5 border-2 rounded-lg mt-2">
												<div className={styles.bodyTable}>{item?.voucher_type_name}</div>
												<div className={styles.bodyTable}>{item?.acquired_date}</div>
												<div className={styles.bodyTable}>{item?.start_date}</div>
												<div className={styles.bodyTable}>{item?.end_date}</div>
												<div className={styles.bodyTable}>
													<Checkbox data-props={item} checked={checkedItems[item.voucher_no] || false} onChange={(e) => handleCheckboxChange(e as any)}></Checkbox>
												</div>
											</div>
										);
									})}
								</div>
							}
							{!fetchOfferData || fetchOfferData.length <= 0 ? <div className="mt-6 text-bold text-base text-center">No offers to Redeem </div> : <></>}
							{fetchOfferData ? (
								<>
									<div className="flex items-center justify-between mt-6">
										<div className="font-bold text-base">
											{(() => {
												const selectedCount = Object.values(checkedItems).filter(Boolean).length;
												return selectedCount > 0 ? `${selectedCount} voucher(s) selected` : "No vouchers selected";
											})()}
										</div>
									</div>
									<div className="grid grid-cols-2">
										<Form.Item
											className="mb-auto mt-6"
											label={<Label label="Receipt Number" classes={{ label: styles?.basic_input_label }} requiredMark />}
											name="receipt"
											extra={codeCountError && !receipt && <ErrorMessage classes={styles?.err_message} message="This field is required" />}
										>
											<Input className={`${styles?.input_field}  ${receipt || ""}`} placeholder="" value={receipt} onChange={(e) => handleReceipt(e.target.value as any)} />
										</Form.Item>
									</div>
									<div className="grid grid-cols-2">
										<Form.Item
											className="mb-0 mt-6"
											label={<Label label="Remarks" classes={{ label: styles?.basic_input_label }} requiredMark />}
											name="remarks"
											extra={codeCountError && !remarks && <ErrorMessage classes={styles?.err_message} message="This field is required" />}
										>
											<Input.TextArea
												value={remarks}
												data-testid="1"
												placeholder=""
												onChange={(e) => handleRemarks(e.target.value as any)}
												// className={`${fieldErrors?.reason || !inputFields?.reason ? styles?.basic_textarea_error : styles?.basic_textarea_active}`}
												rows={4}
												style={{ width: "100%", borderRadius: "0.5rem", border: "2px solid #dfe1e6" }}
											/>
										</Form.Item>
									</div>
									<div className="grid grid-cols-2 place-items-end mt-6 gap-4">
										<div className="col-span-2 flex justify-end space-x-4">
											<Button label="Clear All" background="yellow" onClick={() => handleClearAll("All Fields has been cleared")} />
											<Button label="Redeem Offers And Download Report" /* type={isButtonEnabled ? "activeLong" : "disabledLong"}*/ onClick={redeemOfferSubmit} />
										</div>
									</div>
								</>
							) : (
								<></>
							)}
						</>
					) : (
						<></>
					)}
				</Form>
			</div>
		</div>
	);
};

export default OfferRedemptionPage;
